import { post } from './http'
import global from '@/api/global'

// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,impDriverStandingBookExcel
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
var name = global.driverNameT
// 司机查询
export const cDlist = p => post(name + '/cDriverInfo/list', p)
// 司机添加
export const cDadd = p => post(name + '/cDriverInfo/addPc', p)
// 司机修改
export const cDupdate = p => post(name + '/cDriverInfo/updatePC', p)
// 司机删除
export const cDdelete = p => post(name + '/cDriverInfo/delete', p)
// 车辆查询
export const cVIlist = p => post(name + '/cVehicleInfo/list', p)
// 车辆添加
export const cVIadd = p => post(name + '/cVehicleInfo/addPC', p)
export const cVIaddD = p => post(name + '/cDriverVehicleRel/addDriverVehicle', p)
// 车辆导入
export const impVehicleInfoExcel = p => post(name + '/cVehicleInfo/impVehicleInfoExcel', p)
// 车辆修改
export const cVIupdate = p => post(name + '/cVehicleInfo/updatePC', p)

// 车辆删除
export const cVIdelete = p => post(name + '/cVehicleInfo/delete', p)
// 车长查询
export const cVLlist = p => post(name + '/cVehicleLong/list', p)
// 车长添加
export const cVLadd = p => post(name + '/cVehicleLong/add', p)
// 车长修改
export const cVLupdate = p => post(name + '/cVehicleLong/update', p)
// 车长删除
export const cVLdelete = p => post(name + '/cVehicleLong/delete', p)
// 车辆类型查询
export const cVTlist = p => post(name + '/cVehicleType/list', p)
// 车辆类型添加
export const cVTadd = p => post(name + '/cVehicleType/add', p)
// 车辆类型修改
export const cVTupdate = p => post(name + '/cVehicleType/update', p)
// 车辆类型删除
export const cVTdelete = p => post(name + '/cVehicleType/delete', p)
// 使用性质列表
export const cVPlist = p => post(name + '/cVehiclePurpose/list', p)
// 使用性质添加
export const cVPadd = p => post(name + '/cVehiclePurpose/add', p)
// 使用性质修改
export const cVPupdate = p => post(name + '/cVehiclePurpose/update', p)
// 使用性质删除
export const cVPdelete = p => post(name + '/cVehiclePurpose/delete', p)
// 车辆排放标准列表
export const cVElist = p => post(name + '/cVehicleEmissionStandards/list', p)
// 车辆排放标准添加
export const cVEadd = p => post(name + '/cVehicleEmissionStandards/add', p)
// 车辆排放标准修改
export const cVEupdate = p => post(name + '/cVehicleEmissionStandards/update', p)
// 车辆排放标准删除
export const cVEdelete = p => post(name + '/cVehicleEmissionStandards/delete', p)
// 获取车辆信息
export const getCVehicleInfo = p => post(name + '/cVehicleInfo/getCVehicleInfo', p)
// 获取司机信息
export const getCDriverInfo = p => post(name + '/cDriverInfo/getCDriverInfoPC', p)
// 开通账号
export const openAccount = p => post(name + '/cDriverAccount/openAccount', p)
// 车辆台账导入
export const impDriverStandingBookExcel = p => post(name + '/driverStandingBook/impDriverStandingBookExcel', p)
// 车辆台账数据查询
export const getDriverStandingBookPage = p => post(name + '/driverStandingBook/getDriverStandingBookPage', p)
// 所属司机下拉
export const getRelationCustomerFleet = p => post(name + '/cVehicleInfo/getRelationCustomerFleet', p)
// 司机修改
export const detailDriver = p => post(name + '/cDriverInfo/detailDriver', p)
// 添加银行卡
export const CDBadd = p => post(name + '/cDriverBankCard/add', p)
// 修改银行卡
export const CDBupdate = p => post(name + '/cDriverBankCard/update', p)
// 设置默认
export const updateDefault = p => post(name + '/cDriverBankCard/updateDefault', p)
// 银行卡列表
export const CDBlist = p => post(name + '/cDriverBankCard/list', p)
// 银行卡删除
export const CDBdelete = p => post(name + '/cDriverBankCard/delete', p)
// 指派司机列表//平台1 车队2 货主3
export const assignDriverList = p => post(name + '/cDriverInfo/assignDriverList', p)
// 指派车辆列表
export const getCVehicleInfoListByDriverId = p => post(name + '/cVehicleInfo/getCVehicleInfoListByDriverId', p)
// 能源类型列表
export const cVhcEnergyTypeList = p => post(name + '/cVhcEnergyType/list', p)
// 车牌颜色列表
export const cVhcNoColourList = p => post(name + '/cVhcNoColour/list', p)
// 根据司机id查车辆列表（所有车辆）配货端用
export const getCVehicleExtAllByDriverId = p => post(name + '/cVehicleInfo/getCVehicleExtAllByDriverId', p)
// 根据司机id查车辆列表（所有车辆）海运系统用
export const getCVehicleInfoAllByDriverId = p => post(name + '/cVehicleInfo/getCVehicleInfoAllByDriverId', p)
// 根据车牌号查司机
export const getCDriverInfoListByVhcNo = p => post(name + '/cDriverInfo/getCDriverInfoListByVhcNo', p)
// 根据车队长查司机
export const assignCaptainDriverList = p => post(name + '/cDriverInfo/assignCaptainDriverList', p)
// 挂靠声明
export const getStatementByVchId = p => post(name + '/cVehicleStatement/getStatementByVchId', p)
// 运力列表
export const transportCapacityList = p => post(name + '/cDriverVehicleRel/transportCapacityList', p)
// 运力新增
export const cDriverVehicleRelAdd = p => post(name + '/cDriverVehicleRel/add', p)
// 运力上传
export const insertFile = p => post(name + '/cDriverVehicleRel/insertFile', p)
// 运力删除
export const cDriverVehicleRelDelete = p => post(name + '/cDriverVehicleRel/delete', p)
// 运力提交
export const CDVsubmitRel = p => post(name + '/cDriverVehicleRel/submitRel', p)
// 找车列表
export const driverFound = p => post(name + '/driverFound/list', p)
// 找车详情
export const tenantDriverLogDetail = p => post(name + '/tenantDriverLog/detail', p)
// 找车记录
export const carSearchRecord = p => post(name + '/tenantDriverLog/list', p)
// 常走路线添加（平）
export const cUsualLineAdd = p => post(name + '/cUsualLine/add', p)
// 常走路线修改（平）
export const cUsualLineUpdate = p => post(name + '/cUsualLine/update', p)
// 常走路线删除（平）
export const cUsualLineDelete = p => post(name + '/cUsualLine/delete', p)
// 常走路线列表（平）
export const cUsualLineList = p => post(name + '/cUsualLine/list', p)
// 设置偏好货物（平）
export const addOrUpdate = p => post(name + '/cPreferenceGoods/addOrUpdate', p)
// 偏好货物列表（平）
export const cPreferenceGoodsList = p => post(name + '/cPreferenceGoods/list', p)
// 货主端 基础信息-长协车队 列表（平）
export const selectTenantLongCarriageList = p => post(name + '/api/selectTenantLongCarriageList', p)
// 货主端 发布货源-排放标准（平）
export const cVehicleEmissionStandards = p => post(name + '/cVehicleEmissionStandards/list', p)
// 货主端 发布货源-能源类型（平）
export const cVhcEnergyType = p => post(name + '/cVhcEnergyType/list', p)
// 司机端账号列表（平）
export const cDriverAccountList = p => post(name + '/cDriverAccount/list', p)
// 司机端账号删除（平）
export const deleteAccount = p => post(name + '/cDriverAccount/deleteAccount', p)
// 司机端账号-变更账号（平）
export const updateAccount = p => post(name + '/cDriverAccount/updateAccount', p)
// 车队端新增接口（常）
export const fleetVehicleList = p => post(name + '/cVehicleInfo/fleetVehicleList', p)// 车队端车辆列表
export const fleetAddVehicle = p => post(name + '/cVehicleInfo/fleetAddVehicle', p)// 车队端关联车辆
export const fleetDriverList = p => post(name + '/cDriverInfo/fleetDriverList', p)// 车队端司机列表
export const fleetAddDriver = p => post(name + '/cDriverInfo/fleetAddDriver', p)// 车队端关联司机
// 司机解绑（常）
export const fleetDelDriver = p => post(name + '/cDriverInfo/fleetDelDriver', p)
// 车辆解绑（常）
export const fleetDelVehicle = p => post(name + '/cVehicleInfo/fleetDelVehicle ', p)

// 司机上报
export const uploadWlhyJsy = p => post(name + '/cDriverInfo/uploadWlhyJsy', p)
// 车辆上报
export const uploadWlhyCl = p => post(name + '/cVehicleInfo/uploadWlhyCl', p)
